import { ActionTypes } from "../ActionTypes"

const OrderCountAction = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: "ORDER_COUNT",
        payload: data
    })
}

const orderCountsBulkFetchComplete = (dispatch) => {
    dispatch({ type: ActionTypes.ORDER_COUNTS_BULK_FETCH_COMPLETE })
}

const orderCountsBulkFetchReset = (dispatch) => {
    dispatch({ type: ActionTypes.ORDER_COUNTS_BULK_FETCH_RESET })
}

const productCountsBulkFetchComplete = (dispatch) => {
    dispatch({ type: ActionTypes.PRODUCT_COUNTS_BULK_FETCH_COMPLETE })
}

const productCountsBulkFetchReset = (dispatch) => {
    dispatch({ type: ActionTypes.PRODUCT_COUNTS_BULK_FETCH_RESET })
}
const RTOCountAction = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: "RTO_ORDER_COUNT",
        payload: data
    })
}
const InventoryCountAction = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: "INVENTORY_COUNT",
        payload: data
    })
}
const InventoryCountUpdateAction = (dispatch, data) => {
    dispatch({
        type: "INVENTORY_COUNT_UPDATE",
        payload: data
    })
}
const leadChatCount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.LEAD_CHAT_COUNT,
        payload: data
    })
}

const totalLeadCount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.TOTAL_LEAD_COUNT,
        payload: data
    })
}

const leadCount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.LEAD_COUNT,
        payload: data
    })
}


const ActiveProductCount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.ACTIVE_PRODUCT_COUNT,
        payload: data
    })
}

const HidePriceVerification = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: "PRICE_VERIFICATION_PENDING_MENU",
        payload: data
    })
}
const QCRequestSend = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.QC_REQUEST_SEND,
        payload: data
    })
}
const SellerVerified = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.VERIFIED_SELLER,
        payload: data
    })
}
const updateSellerCount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.UPDATE_SELLER_MESSAGE_COUNT,
        payload: data
    })
}
const updateProductActReqCount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.PRODUCT_ACTION_REQUIRED_COUNT,
        payload: data
    })
}
const updateBlockedVendorStatus = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.BLOCKED_STATUS,
        payload: data
    })
}
const upadteQuesCount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.UPADTE_QUESTION_COUNT,
        payload: data
    })
}

const upadteWalletAmount = (dispatch, data) => {
    // console.log("disptch",data)
    dispatch({
        type: ActionTypes.WALLET_AMOUNT,
        payload: data
    })
}

const OpportunityCountAction = (dispatch, data) => {
    dispatch({
        type: "OPPORTUNITY_COUNT",
        payload: data
    })
}
const OpportunityOutOfStockCountAction = (dispatch, data) => {
    dispatch({
        type: "OPPORTUNITY_OUT_OF_STOCK_COUNT",
        payload: data
    })
}
const toggleSideBar = (dispatch, data) => {
    dispatch({
        type: ActionTypes.SHOW_HIDE_MENU,
        payload: data
    })
}
//SL-660 Grab Order
const GrabOrderCountAction = (dispatch, data) => {
    dispatch({
        type: "GRAB_ORDER_COUNT",
        payload: data
    })
}

//SL-710 Seller Lead : Subscription Details
const LeadSubscriptionDetail = (dispatch, data) => {
    dispatch({
        type: ActionTypes.LEAD_SUBSCRIPTION,
    })
}

//SL-741 Pending notice
const PendingNoticeCountAction = (dispatch, data) => {
    dispatch({
        type: "PENDING_NOTICE_COUNT",
        payload: data
    })
}


//SL-741
const updatePendingNoticeCount = (dispatch, data) => {
    dispatch({
        type: "UPDATE_NOTICE_COUNT",
        payload: data
    })
}


// SL-890
const updateGrabOrderPopupState = (dispatch, data) => {
    dispatch({
        type: ActionTypes.GRAB_ORDER_POPUP,
       payload: data
    })
}

//SL-923
/**
 * Dispatch Vendor Address
 * @param {*} dispatch 
 * @param {*} data 
 */
const updateSellerAddress = (dispatch, data) => {
    dispatch({
        type: ActionTypes.SELLER_ADDRESS,
        payload: data
    })
}

// Start SL-768
const updateNotificationCount = (dispatch, data) => {
    dispatch({
        type: ActionTypes.NOTIFICATION_COUNT,
        payload: data
    })
}
// End SL-768

const updateProductOpportunityCount = (dispatch, data) => {
    dispatch({
        type: ActionTypes.PRODUCT_OPPORTUNITY_COUNT,
        payload: data
    })
}

const updateRecommendedProductOpportunityCount = (dispatch, data) => {
    dispatch({
        type: ActionTypes.RECOMMENDED_PRODUCT_OPPORTUNITY_COUNT,
        payload: data
    })
}


export const Actions={
    OrderCountAction,
    orderCountsBulkFetchComplete,
    orderCountsBulkFetchReset,
    productCountsBulkFetchComplete,
    productCountsBulkFetchReset,
    RTOCountAction,
    InventoryCountAction,
    InventoryCountUpdateAction,
    QCRequestSend,
    HidePriceVerification,
    SellerVerified,
    updateSellerCount,
    updateProductActReqCount,
    ActiveProductCount,
    upadteQuesCount,
    upadteWalletAmount,
    leadChatCount,
    leadCount,
    totalLeadCount,
    OpportunityCountAction,
    toggleSideBar,
    updateBlockedVendorStatus,
    OpportunityOutOfStockCountAction,
    GrabOrderCountAction,
    LeadSubscriptionDetail,
    PendingNoticeCountAction,
    updatePendingNoticeCount,
    updateGrabOrderPopupState,
    updateSellerAddress,//SL-923
    updateNotificationCount, // SL-768
    updateProductOpportunityCount,
    updateRecommendedProductOpportunityCount
}